import { useAuth } from '../contexts';
import { ADMIN_ROLE_IDS } from '../enums/UserRoleId.enum';

/**
 * Hook to determine if the current user can see debug information
 * @returns {boolean} true if user is admin OR has showDebug enabled
 */
export const useCanSeeDebug = (): boolean => {
  const { user } = useAuth();
  const isAdminUser = user?.role_id && ADMIN_ROLE_IDS.has(user.role_id);
  // Only show debug if showDebug is explicitly true
  // Admin users must also have showDebug enabled
  const result = user?.showDebug === true;

  // // Debug logging
  // console.log('useCanSeeDebug:', {
  //   userId: user?.id,
  //   roleId: user?.role_id,
  //   isAdminUser,
  //   showDebug: user?.showDebug,
  //   showDebugType: typeof user?.showDebug,
  //   result
  // });

  return result;
};
